import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import StudioSelect from "../../StudioSelect.vue";
import type { DialogueStyleDefinition } from "../types/DialogueNode";


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogueStyleSelect',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StudioSelect, {
    class: "dialogue-style-select",
    "model-value": __props.modelValue,
    options: __props.options,
    label: "对话样式",
    compact: "",
    "show-id": "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
  }, null, 8, ["model-value", "options"]))
}
}

})